var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVr360(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.937,
    height: 31.105,
    viewBox: "0 0 41.937 31.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_360-degree",
    "data-name": "360-degree",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42400",
    "data-name": "Path 42400",
    d: "M308.528,159.573a1.229,1.229,0,0,1-.154-2.447,26.837,26.837,0,0,0,9.789-2.963c2.223-1.295,3.447-2.817,3.447-4.286,0-1.619-1.432-2.944-2.634-3.771a1.229,1.229,0,0,1,1.393-2.024c2.419,1.664,3.7,3.668,3.7,5.8,0,2.414-1.614,4.631-4.667,6.409a28.88,28.88,0,0,1-10.716,3.277A1.3,1.3,0,0,1,308.528,159.573Zm0,0",
    transform: "translate(-282.13 -132.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42401",
    "data-name": "Path 42401",
    d: "M20.669,152.145l-3.276-3.276a1.229,1.229,0,0,0-1.738,1.737l.957.957a29.6,29.6,0,0,1-9.587-2.475c-2.9-1.4-4.568-3.175-4.568-4.879,0-1.446,1.192-2.949,3.357-4.232a1.229,1.229,0,1,0-1.253-2.114C.791,140.1,0,142.547,0,144.208c0,2.726,2.117,5.245,5.96,7.094a32.694,32.694,0,0,0,11.046,2.767l-1.352,1.352a1.229,1.229,0,0,0,1.738,1.738l3.276-3.276A1.229,1.229,0,0,0,20.669,152.145Zm0,0",
    transform: "translate(0 -126.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42402",
    "data-name": "Path 42402",
    d: "M98.659,98.085v-.3c0-1.043-.638-1.245-1.494-1.245-.529,0-.7-.467-.7-.934s.171-.934.7-.934c.591,0,1.214-.078,1.214-1.338,0-.9-.514-1.12-1.152-1.12-.762,0-1.152.187-1.152.794,0,.529-.234.887-1.136.887-1.12,0-1.26-.234-1.26-.981,0-1.214.871-2.785,3.548-2.785,1.977,0,3.471.716,3.471,2.817A2.733,2.733,0,0,1,99.5,95.5a2.256,2.256,0,0,1,1.587,2.288v.3c0,2.552-1.758,3.517-3.937,3.517-2.677,0-3.7-1.634-3.7-2.941,0-.7.3-.887,1.152-.887,1,0,1.245.218,1.245.809,0,.731.685.9,1.385.9C98.285,99.486,98.659,99.1,98.659,98.085Zm0,0",
    transform: "translate(-85.791 -82.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42403",
    "data-name": "Path 42403",
    d: "M216.415,97.79v.14c0,2.677-1.665,3.673-3.813,3.673s-3.829-1-3.829-3.673V93.806c0-2.677,1.727-3.673,3.969-3.673,2.63,0,3.673,1.634,3.673,2.926,0,.747-.358.98-1.136.98-.669,0-1.261-.171-1.261-.887,0-.591-.622-.9-1.354-.9-.918,0-1.463.482-1.463,1.556v1.4a2.489,2.489,0,0,1,1.946-.685C214.921,94.521,216.415,95.3,216.415,97.79ZM211.2,98.1c0,1.074.529,1.541,1.4,1.541s1.385-.467,1.385-1.541v-.14c0-1.136-.513-1.572-1.4-1.572a1.249,1.249,0,0,0-1.385,1.432Zm0,0",
    transform: "translate(-191.673 -82.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42404",
    "data-name": "Path 42404",
    d: "M325.055,97.93V93.806c0-2.677,1.665-3.673,3.813-3.673s3.828,1,3.828,3.673V97.93c0,2.677-1.681,3.673-3.828,3.673S325.055,100.606,325.055,97.93Zm5.213-4.124c0-1.074-.529-1.556-1.4-1.556s-1.385.482-1.385,1.556V97.93c0,1.074.514,1.556,1.385,1.556s1.4-.482,1.4-1.556Zm0,0",
    transform: "translate(-298.43 -82.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42405",
    "data-name": "Path 42405",
    d: "M413.037,7.372a3.686,3.686,0,1,1,3.686-3.686A3.69,3.69,0,0,1,413.037,7.372Zm0-4.914a1.229,1.229,0,1,0,1.229,1.229A1.23,1.23,0,0,0,413.037,2.457Zm0,0",
    transform: "translate(-375.822)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVr360);
export default __webpack_public_path__ + "static/media/vr-360.98bb24ea0800c194c892f571b2132f52.svg";
export { ForwardRef as ReactComponent };